export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M20 3.501a1 1 0 011 1v15a1 1 0 01-1 1H4a1.001 1.001 0 01-1-1V4.5a1 1 0 011-1l16 .001zm-15 12v3h2v-3H5zm4 0v3h10v-3H9zm-4-2h2v-3H5v3zm4 0h10v-3H9v3zm-4-5h2v-3H5v3zm4 0h10v-3H9v3z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};